import { render, staticRenderFns } from "./index-agent.vue?vue&type=template&id=0abbedf4"
import script from "./index-agent.vue?vue&type=script&lang=js"
export * from "./index-agent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports